import type { MembershipTenant } from '@atomfit/shared';

export function resolveMembershipTenant(
  tenants: MembershipTenant[],
  selection: { tenantId: string; gymId?: string },
) {
  // A legacy gym selection must follow the gym's current owner after migration.
  return selection.gymId
    ? (tenants.find((tenant) => tenant.gyms.some((gym) => gym.id === selection.gymId)) ?? null)
    : (tenants.find((tenant) => tenant.id === selection.tenantId) ?? null);
}

export function filterMembershipTenants(tenants: MembershipTenant[], query: string) {
  const q = query.trim().toLocaleLowerCase();
  return tenants.filter((tenant) =>
    `${tenant.name} ${tenant.gyms.map((gym) => `${gym.name} ${gym.city} ${gym.addressLine1}`).join(' ')}`
      .toLocaleLowerCase()
      .includes(q),
  );
}
